class Hotspots {
  constructor() {
    this.init();
  }

  init() {
    var hotspotSliders = document.querySelectorAll('.hotspot-slider');
    
    if (hotspotSliders) {
      hotspotSliders.forEach((hotspotSlider) => {
        var hotspots = hotspotSlider.querySelectorAll('.hotspots__hotspot');
        var slides = hotspotSlider.querySelectorAll('.carousel-main .js-carousel-slide');
    
        var mainSlider = hotspotSlider.querySelector('.carousel-main');
        mainSlider.addEventListener('mouseenter', () => {
          if (mainSlider.dataset.sliderAutoplay == 'true') {
            mainSlider.setAttribute("data-slider-autoplay", false);
            mainSlider.playPauseState = 'paused';
          }
        });
    
        hotspotSlider.addEventListener('mouseleave', () => {
          if (mainSlider.dataset.sliderAutoplay == 'false') {
            mainSlider.setAttribute("data-slider-autoplay", true);
            mainSlider.playPauseState = 'playing';
          }
        });
  
        if (hotspots) {
          hotspots.forEach((hotspot) => {
            if (slides) {
              hotspot.addEventListener("click", () => {
                hotspot.classList.toggle('hotspot--active');
              });
            }
          });
        }
      });
    }
  
    if (Shopify.designMode) {  
      let hotspotSlideIndex = null;
    
      const carouselSlider = document.querySelector('#hotspotMainSlider');
    
      const goToHotspotSlide = (index) => {
        carouselSlider.dispatchEvent(new CustomEvent('slider:go', {
          detail: {
            index: index + 1,
            skipCheck: true,
            skipAnimation: true
          }
        }))
      }
    
      document.addEventListener('shopify:block:select', (event) => {
        if (!carouselSlider) return;
    
        const carouselSlide = event.target.closest('.js-carousel-slide');
        const carouselSlides = carouselSlider.querySelectorAll('.js-carousel-slide');
        const slideIndex = Array.from(carouselSlides).indexOf(carouselSlide);
    
        if (slideIndex === -1) return;
    
        hotspotSlideIndex = slideIndex;
        goToHotspotSlide(hotspotSlideIndex)
      });
    
      document.addEventListener('shopify:block:deselect', () => {
        hotspotSlideIndex = null;
      });
  
      document.addEventListener('shopify:section:load', (event) => {
        if (!carouselSlider) return;

        if (hotspotSlideIndex !== null) {
          goToHotspotSlide(hotspotSlideIndex);
        }
      });
  
      document.addEventListener('shopify:section:unload', () => {
        hotspotSlideIndex = null;
      });
    }
  }
}

new Hotspots();

if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', () => {
    new Hotspots();
  });
}
